import React from 'react';
import { useParams } from 'react-router-dom';
import { Argument } from '../Arguments/Argument/Argument';
import ArgumentList from '../Arguments/ArgumentList/ArgumentList';

export const getArgumentsListPathValue = (commonPath: string) =>
    `${commonPath}/arguments`;

// FIXME use nested urls instead
export const useArgumentPathValue = (
    commonPath: string,
    isPdfModeActivated: boolean,
) => {
    const { argumentId } = useParams();
    const argumentsListPath = getArgumentsListPathValue(commonPath);
    let path = argumentsListPath;
    if (argumentId) {
        const urlSuffix = isPdfModeActivated ? '/pdf' : '';
        path = `${argumentsListPath}/${argumentId}${urlSuffix}`;
    }

    return path;
};

// FIXME use nested urls instead
export const useArgumentComponent = (resourceName: string) => {
    const { argumentId } = useParams();
    if (argumentId) return <Argument />;

    return <ArgumentList resourceName={resourceName} />;
};
